import Request from '../../data/request'

export default class ApiExport {

    constructor() {

    }

    eventsUrl(companyId:ID, projectId:ID, startDateStr:string, endDateStr:string, eventTypes:any[], format:any) {
        const type = format === 'csv' ? 'export-csv' : 'export-ics';
        let url = gdConfig.apiUrl+"company/"+gd.companyId+"/"+type+"/events?";

        if (startDateStr && endDateStr) {
            url += "startDate="+startDateStr+"&endDate="+endDateStr;
        }

        if (projectId) url += "&projectId="+projectId;

        if (eventTypes){
            eventTypes.map(et=>{
                url += "&eventType="+et;
            });
        }

        return url;
    }

    timeSheetUrl(companyId:ID, projectId:ID, userId:ID, startDateStr:string, endDateStr:string, fields:string[]) {
        let url = gdConfig.apiUrl+"export-csv/time-sheet?companyId="+companyId+"&projectId="+projectId+"&userId="+userId;

        if (startDateStr) url += "&startDate="+startDateStr;
        if (endDateStr) url += "&endDate="+endDateStr;

        if (fields) url += "&fields="+fields.join(',');

        return url;
    }

    timeReportsGroupedByTaskUrl(companyId:ID, projectId:ID, userId:ID, startDateStr:string, endDateStr:string, fields:string[]) {
        let url = gdConfig.apiUrl+"export-csv/time-report?companyId="+companyId+"&projectId="+projectId+"&userId="+userId;

        if (startDateStr) url += "&startDate="+startDateStr;
        if (endDateStr) url += "&endDate="+endDateStr;

        if (fields) url += "&fields="+fields.join(',');

        return url;
    }


    projectTasks(projectId:ID, taskIds:ID[]) {
        return new Request(this, 'POST', 'export-csv/project-tasks', {
            projectId: projectId,
            taskIds: taskIds
        });
    }
}
